import React, {Component} from 'react'
import { Link } from 'react-router-dom'

class OperacoeItinerarioEmLote extends Component {
    render() {
        return (
            <div className="dropdown">
                <button className="vx-btn-secondary dropdown-toggle" type="button" id="dropdownMenuEmLote"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i className="material-icons" style={{ fontSize: '18px' }}>tune</i>
                    Alterações em lote
                </button>
                <div className="dropdown-menu vx-actions-menu" aria-labelledby="dropdownMenuEmLote">
                    <a className="dropdown-item vx-action-item" data-toggle="modal"
                       data-target="#modalAlteracaoVeiculoItinerarioEmLote">
                        <i className="material-icons">directions_bus</i> Alterar veículo
                    </a>
                    <a className="dropdown-item vx-action-item" data-toggle="modal"
                       data-target="#modalAlteracaoTipoAjusteItinerarioEmLote">
                        <i className="material-icons">local_offer</i> Alterar desconto/acréscimo
                    </a>
                    <a className="dropdown-item vx-action-item" data-toggle="modal"
                       data-target="#ModalAlteracaoTipoPrecoItinerarioEmLote">
                        <i className="material-icons">label</i> Alterar categoria
                    </a>
                    {this.props.habilitadoSite && (
                        <a className="dropdown-item vx-action-item" data-toggle="modal"
                           data-target="#modalHabilitarVendasEmLoteNoSite">
                            <i className="material-icons">public</i> Alterar venda no site
                        </a>
                    )}
                    <a className="dropdown-item vx-action-item" data-toggle="modal"
                       data-target="#modalAlteracaoPrestadorItinerarioEmLote">
                        <i className="material-icons">person</i> Alterar prestador
                    </a>
                    <a className="dropdown-item vx-action-item" data-toggle="modal"
                       data-target="#modalBloquearItinerarioPorCidadeEmLote">
                        <i className="material-icons">location_city</i> Bloquear por cidade
                    </a>
                    <a className="dropdown-item vx-action-item" data-toggle="modal"
                       data-target="#modalBloquearUsuarioEmpresaItinerarioPorEmLote">
                        <i className="material-icons">lock</i> Bloquear venda por usuário
                    </a>
                    <Link className="dropdown-item vx-action-item" to='/painel-ativacao-itinerario'>
                        <i className="material-icons">power_settings_new</i> Alterar ativo/inativo
                    </Link>
                </div>
            </div>
        );
    }
}

export default OperacoeItinerarioEmLote
